import EditCowModal from "./edit-cow-modal.vue";

export default EditCowModal;



// WEBPACK FOOTER //
// ./src/components/_modals/edit-cow/index.js